import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DMCustCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.dm.customer.create(0));
  };

  return (
    <MainMenuItem
      itemTitleString="DMを作成する(お客様)"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DMCustCreateMenuItem;
